'use strict';

const runExperiment = eligibilityObj => {
  const { gc_param, name } = eligibilityObj || {};

  if (!name) return false;

  let passCheckoutParam = false;

  window.Finch.experiment(name, {
    Control() {},
    Treatment() {
      passCheckoutParam = gc_param;
    },
  });

  return passCheckoutParam;
};

module.exports = ({ payloadData, ev }, callback) => {
  const { guestCheckoutEligibility } = payloadData || {};

  if (ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }

  const passCheckoutParam = runExperiment(guestCheckoutEligibility);

  if (callback) {
    callback(passCheckoutParam);
  }

  return false;
};
